export const productsObject = {
  NECK_BRACE: {
    name: "Minerve",
    routeName: "NeckBraceProduct",
    tableName: "minerva",
    resetProductForm: "minerva/resetProduct",
    productModuleName: "minerva",
    productStateProp: "minerva",
    getLocalProduct: "minerva/getFromLocal",
    getRemoteProduct: "minerva/get",
    createRemoteProduct: "minerva/createMinerva"
  },

  MOLDED_SEAT: {
    name: "Siège moulé",
    routeName: "MoldedSeatProduct",
    tableName: "molded_seat",
    resetProductForm: "moldedSeat/resetProduct",
    productModuleName: "moldedSeat",
    productStateProp: "moldedSeat",
    getLocalProduct: "moldedSeat/getLocalMoldedSeat",
    getRemoteProduct: "moldedSeat/get",
    createRemoteProduct: "moldedSeat/createMoldedSeat"
  },

  LIFT: {
    name: "Verticalisateur",
    routeName: "LiftProduct",
    tableName: "lift",
    resetProductForm: "lift/resetProduct",
    productModuleName: "lift",
    productStateProp: "lift",
    getLocalProduct: "lift/getFromLocal",
    getRemoteProduct: "lift/get",
    createRemoteProduct: "lift/createLift"
  },

  OTN: {
    name: "OTN",
    routeName: "OtnProduct",
    tableName: "otn",
    resetProductForm: "otn/resetProduct",
    productModuleName: "otn",
    productStateProp: "otn",
    getLocalProduct: "otn/getFromLocal",
    getRemoteProduct: "otn/get",
    createRemoteProduct: "otn/createOtn"
  },

  CORSET: {
    name: "Corset",
    routeName: "CorsetProduct",
    tableName: "corset",
    resetProductForm: "corset/resetProduct",
    productModuleName: "corset",
    productStateProp: "corset",
    getLocalProduct: "corset/getFromLocal",
    getRemoteProduct: "corset/get",
    createRemoteProduct: "corset/createCorset"
  },

  POSITIONING_SEAT: {
    name: "Selle de positionnement",
    routeName: "PositioningSeatProduct",
    tableName: "positioning_seat",
    resetProductForm: "positioningSeat/resetProduct",
    productModuleName: "positioningSeat",
    productStateProp: "positioningSeat",
    getLocalProduct: "positioningSeat/getFromLocal",
    getRemoteProduct: "positioningSeat/get",
    createRemoteProduct: "positioningSeat/createPositioningSeat"
  },

  SEAT: {
    name: "Selle",
    routeName: "SeatProduct",
    tableName: "seat",
    resetProductForm: "seat/resetProduct",
    productModuleName: "seat",
    productStateProp: "seat",
    getLocalProduct: "seat/getFromLocal",
    getRemoteProduct: "seat/get",
    createRemoteProduct: "seat/createSeat"
  },

  RETOUCHING_REPAIR: {
    name: "Retouche / Réparation",
    routeName: "RetouchingRepairProduct",
    tableName: "retouching_repair",
    resetProductForm: "retouchingRepair/resetProduct",
    productModuleName: "retouchingRepair",
    productStateProp: "retouchingRepair",
    getLocalProduct: "retouchingRepair/getFromLocal",
    getRemoteProduct: "retouchingRepair/get",
    createRemoteProduct: "retouchingRepair/createRetouchingRepair"
  },

  UPPER_LIMB_ORTHOSIS: {
    name: "Orthèse M sup",
    routeName: "UpperLimbProduct",
    tableName: "upper_limb",
    resetProductForm: "upperLimb/resetProduct",
    productModuleName: "upperLimb",
    productStateProp: "upperLimb",
    getLocalProduct: "upperLimb/getFromLocal",
    getRemoteProduct: "upperLimb/get",
    createRemoteProduct: "upperLimb/createUpperLimb"
  },

  LOWER_LIMB_ORTHOSIS: {
    name: "Orthèse M inf",
    routeName: "LowerLimbProduct",
    tableName: "lower_limb",
    resetProductForm: "lowerLimb/resetProduct",
    productModuleName: "lowerLimb",
    productStateProp: "lowerLimb",
    getLocalProduct: "lowerLimb/getFromLocal",
    getRemoteProduct: "lowerLimb/get",
    createRemoteProduct: "lowerLimb/createLowerLimb"
  }
};
